<div class="flex flex-col">
  <div class="flex items-start gap-3 mb-4">
    <div class="w-1 h-8 bg-[#3D3DF4] rounded-full shrink-0"></div>
    <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-tight">Conexiones</h2>
  </div>
  <div
    class="bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.5rem] md:rounded-2xl p-4 xl:p-6 flex-1">
    <div class="grid grid-cols-2 xl:grid-cols-4 gap-3 mb-4">
      <div class="bg-blue-50 dark:bg-blue-900/20 rounded-[1rem] p-3 text-center">
        <div
          class="w-8 h-8 mx-auto mb-1.5 bg-blue-100 dark:bg-blue-800/40 rounded-lg flex items-center justify-center">
          <fa-icon [icon]="faChartColumn" class="text-sm text-blue-600 dark:text-blue-400"></fa-icon>
        </div>
        <p class="text-[10px] font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wide">Total</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ totalCount }}</p>
      </div>

      <div class="bg-green-50 dark:bg-green-900/20 rounded-[1rem] p-3 text-center">
        <div
          class="w-8 h-8 mx-auto mb-1.5 bg-green-100 dark:bg-green-800/40 rounded-lg flex items-center justify-center">
          <fa-icon [icon]="faLink" class="text-sm text-green-600 dark:text-green-400"></fa-icon>
        </div>
        <p class="text-[10px] font-bold text-green-600 dark:text-green-400 uppercase tracking-wide">Conectadas</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ connectedCount }}</p>
      </div>

      <div class="bg-red-50 dark:bg-red-900/20 rounded-[1rem] p-3 text-center">
        <div
          class="w-8 h-8 mx-auto mb-1.5 bg-red-100 dark:bg-red-800/40 rounded-lg flex items-center justify-center">
          <fa-icon [icon]="faLink" class="text-sm text-red-600 dark:text-red-400"></fa-icon>
        </div>
        <p class="text-[10px] font-bold text-red-600 dark:text-red-400 uppercase tracking-wide">Desconectadas</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ disconnectedCount }}</p>
      </div>

      <div class="bg-yellow-50 dark:bg-yellow-900/20 rounded-[1rem] p-3 text-center">
        <div
          class="w-8 h-8 mx-auto mb-1.5 bg-yellow-100 dark:bg-yellow-800/40 rounded-lg flex items-center justify-center">
          <fa-icon [icon]="faClock" class="text-sm text-yellow-600 dark:text-yellow-500"></fa-icon>
        </div>
        <p class="text-[10px] font-bold text-yellow-600 dark:text-yellow-500 uppercase tracking-wide">Próximamente</p>
        <p class="text-xl font-bold text-gray-900 dark:text-white">{{ comingSoonCount }}</p>
      </div>
    </div>

    @for (conn of connectedConnections; track conn.id) {
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 py-3 px-3.5 rounded-[1rem] bg-green-50 dark:bg-green-900/10 border border-green-100 dark:border-green-800/30 mt-2">
      <div class="flex items-center gap-3 min-w-0">
        @if (conn.logoUrl) {
        <div class="w-8 h-8 bg-gray-50 dark:bg-gray-700 rounded-lg flex items-center justify-center">
          <img [src]="conn.logoUrl" [alt]="conn.name" class="w-5 h-5 object-contain">
        </div>
        } @else {
        <div
          class="w-8 h-8 bg-gray-50 dark:bg-gray-700 rounded-lg flex items-center justify-center text-xs font-bold text-gray-500 dark:text-gray-400">
          {{ conn.initials }}
        </div>
        }

        <div class="min-w-0">
          <span class="block text-sm font-medium text-gray-700 dark:text-gray-300 truncate">{{ conn.name }}</span>
          <span class="md:hidden text-[11px] font-medium text-green-600 dark:text-green-400 uppercase tracking-wide">Conectada</span>
        </div>
        <span class="w-2 h-2 bg-green-500 rounded-full"></span>
      </div>

      <button (click)="manageConnection.emit(conn.id)"
        class="w-full md:w-auto inline-flex items-center justify-center rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 hover:text-[#3D3DF4] dark:hover:text-[#5D5DF6] uppercase tracking-wide cursor-pointer md:border-0 md:px-0 md:py-0 md:rounded-none">
        GESTIONAR
      </button>
    </div>
    }
  </div>
</div>
